var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("router-link", {
    staticClass: "logo-wrapper",
    attrs: {
      to: "/index"
    }
  }, [!_vm.changeLogo ? _c("div", {
    staticClass: "logo-title verticalMiddle"
  }, [_vm._v("INSURFORCE")]) : _c("div", {
    staticClass: "logo-title verticalMiddle"
  }, [_vm._v("得保科技")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };